import { PaytrieAPI } from '@paytrie/client'

import {
  FormStates,
  STEP_TO_PATH,
  StateValue,
} from '@/panels/signup/FormStateMachine'

type RequirementKey = PaytrieAPI.UserRequirementKey

const RESUME_STEP: Record<Exclude<RequirementKey, 'kyc'>, StateValue> = {
  emailVerification: FormStates.EMAIL,
  phoneVerification: FormStates.PHONE,
  disclosure: FormStates.DISCLOSURE,
  personalInfo: FormStates.PERSONAL_INFO,
  address: FormStates.PERSONAL_INFO,
  occupation: FormStates.OCCUPATION,
  additionalInfo: FormStates.ADDITIONAL_INFO,
  kycRefresh: FormStates.KYC_REFRESH,
}

const CANONICAL_ORDER: RequirementKey[] = [
  'emailVerification',
  'phoneVerification',
  'disclosure',
  'personalInfo',
  'address',
  'occupation',
  'additionalInfo',
  'kyc',
  'kycRefresh',
]

export type ResumeDestination =
  | { type: 'signup'; step: StateValue; path: string }
  | { type: 'upload' }
  | { type: 'in-review' }
  | null

const signupDestination = (step: StateValue): ResumeDestination => ({
  type: 'signup',
  step,
  path: STEP_TO_PATH[step],
})

type RequirementBuckets = Pick<
  PaytrieAPI.UserRequirements,
  'pending' | 'processing' | 'satisfied'
>

export const getResumeDestination = (
  requirements: RequirementBuckets,
  userStatus: string | null | undefined
): ResumeDestination => {
  const processing = new Set(requirements.processing)
  if (processing.has('kyc')) {
    return { type: 'in-review' }
  }

  const pending = new Set(requirements.pending)

  for (const key of CANONICAL_ORDER) {
    if (!pending.has(key)) continue

    if (key === 'kyc') {
      return userStatus === 'upload'
        ? { type: 'upload' }
        : signupDestination(FormStates.KYC_GENERATE_QUESTIONS)
    }

    return signupDestination(RESUME_STEP[key])
  }

  return null
}
